<template>
  <component
    :is="'b-card'"
  >

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="dataReady && campaign === null"
    >
      <h4 class="alert-heading">
        Error fetching campaign data
      </h4>
      <div class="alert-body">
        No campaign found with this id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'dashboard'}"
        >
          Here
        </b-link>
        for other campaigns.
      </div>
    </b-alert>

    <b-tabs
      v-if="dataReady && campaign"
      pills
    >

      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">帳號</span>
        </template>
        <campaign-edit-tab-account
          class="mt-2 pt-75"
        />
      </b-tab>

      <!-- Tab: Information -->
      <b-tab>
        <template #title>
          <feather-icon
            icon="InfoIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">地址</span>
        </template>
        <campaign-edit-tab-address class="mt-2 pt-75" />
      </b-tab>

      <b-tab>
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">疾病管制屬</span>
        </template>
        <campaign-edit-tab-gov-qrcode
          class="mt-2 pt-75"
        />
      </b-tab>

      <!-- Tab: Social -->
      <b-tab>
        <template #title>
          <feather-icon
            icon="Share2Icon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">社交</span>
        </template>
        <campaign-edit-tab-social class="mt-2 pt-75" />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink,
} from 'bootstrap-vue'
import store from '@/store'
import { mapGetters } from 'vuex'
import CampaignEditTabAccount from './CampaignEditTabAccount.vue'
import CampaignEditTabAddress from './CampaignEditTabAddress.vue'
import CampaignEditTabGovQrcode from './CampaignEditTabGovQrcode.vue'
import CampaignEditTabSocial from './CampaignEditTabSocial.vue'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    CampaignEditTabAccount,
    CampaignEditTabAddress,
    CampaignEditTabGovQrcode,
    CampaignEditTabSocial,
  },
  data() {
    return {
      dataReady: false,
    }
  },
  computed: {
    ...mapGetters(['campaign', 'user']),
  },
  mounted() {
    if (this.campaign) {
      this.dataReady = true
    } else {
      store.dispatch('getCampaign', { slug: this.$route.params.slug, cuid: this.user.uid }).then(() => {
        this.dataReady = true
      })
    }
  },
}
</script>
